export const AGORA_APP_ID = '9e0cbc55b92b464880d48feefc47fdca' // set your app id here
export const AGORA_APP_CERTIFICATE = 'f6c472858b0049a7a2a3e8e4da4400b3'